export default __webpack_public_path__ + "static/media/onboardingAsideMb.736efc2c.png";